export const COLLABORATORS_APIS_CREATE_COLLABORATORS_FALSY_PAYLOAD = 'COLLABORATORS_APIS_CREATE_COLLABORATORS_FALSY_PAYLOAD';
export const COLLABORATORS_APIS_CREATE_COLLABORATORS_FALSY_COLLABORATORS = 'COLLABORATORS_APIS_CREATE_COLLABORATORS_FALSY_COLLABORATORS';
export const COLLABORATORS_APIS_CREATE_COLLABORATORS_BAD_SERVER_STATUS = 'COLLABORATORS_APIS_CREATE_COLLABORATORS_BAD_SERVER_STATUS';
export const COLLABORATORS_APIS_CREATE_COLLABORATORS_UNEXPECTED = 'COLLABORATORS_APIS_CREATE_COLLABORATORS_UNEXPECTED';

export const COLLABORATORS_APIS_UPDATE_FALSY_PAYLOAD = 'COLLABORATORS_APIS_UPDATE_FALSY_PAYLOAD';
export const COLLABORATORS_APIS_UPDATE_FALSY_ID = 'COLLABORATORS_APIS_UPDATE_FALSY_ID';
export const COLLABORATORS_APIS_UPDATE_BAD_SERVER_STATUS = 'COLLABORATORS_APIS_UPDATE_BAD_SERVER_STATUS';
export const COLLABORATORS_APIS_UPDATE_UNEXPECTED = 'COLLABORATORS_APIS_UPDATE_UNEXPECTED';

export const COLLABORATORS_APIS_REMOVE_FALSY_PAYLOAD = 'COLLABORATORS_APIS_REMOVE_FALSY_PAYLOAD';
export const COLLABORATORS_APIS_REMOVE_FALSY_ID = 'COLLABORATORS_APIS_REMOVE_FALSY_ID';
export const COLLABORATORS_APIS_REMOVE_BAD_SERVER_STATUS = 'COLLABORATORS_APIS_REMOVE_BAD_SERVER_STATUS';
export const COLLABORATORS_APIS_REMOVE_UNEXPECTED = 'COLLABORATORS_APIS_REMOVE_UNEXPECTED';

export const COLLABORATORS_APIS_INVITE_COLLABORATORS_FALSY_PAYLOAD = 'COLLABORATORS_APIS_INVITE_COLLABORATORS_FALSY_PAYLOAD';
export const COLLABORATORS_APIS_INVITE_COLLABORATORS_UNEXPECTED = 'COLLABORATORS_APIS_INVITE_COLLABORATORS_UNEXPECTED';
export const COLLABORATORS_APIS_INVITE_COLLABORATORS_BAD_SERVER_STATUS = 'COLLABORATORS_APIS_INVITE_COLLABORATORS_BAD_SERVER_STATUS';

export const COLLABORATORS_ACTIONS_CREATE_COLLABORATORS_UNEXPECTED = 'COLLABORATORS_ACTIONS_CREATE_COLLABORATORS_UNEXPECTED';

export const COLLABORATORS_ACTIONS_INVITE_COLLABORATORS_UNEXPECTED = 'COLLABORATORS_ACTIONS_INVITE_COLLABORATORS_UNEXPECTED';

export const COLLABORATORS_ACTIONS_UPDATE_COLLABORATOR_UNEXPECTED = 'COLLABORATORS_ACTIONS_UPDATE_COLLABORATOR_UNEXPECTED';

export const COLLABORATORS_ACTIONS_INVITE_COLLABORATORS_TO_COLLABORATORS_GROUP_UNEXPECTED = 'COLLABORATORS_ACTIONS_INVITE_COLLABORATORS_TO_COLLABORATORS_GROUP_UNEXPECTED';
